// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ihu9","top":"styles_top__1yzG9","left":"styles_left__1bA7A","description":"styles_description__3efRs"};